export const NOTIFICATION_TYPE = {
  0: 'MoveDatesChanged',
  1: 'SendDeviceToTransferee',
  2: 'DeviceNotReturned',
  3: 'NewMoveCreated'
};

export const NOTIFICATION_TYPE_ICON = {
  0: 'calendar_today',
  1: 'add_to_home_screen',
  2: 'backspace',
  3: 'fiber_new'
};